import { render, staticRenderFns } from "./MasterBarang.vue?vue&type=template&id=60b4790d&"
import script from "./MasterBarang.vue?vue&type=script&lang=js&"
export * from "./MasterBarang.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports